import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import * as Sentry from '@sentry/react';
import { API_URL } from '../config/constants';

const baseQuery = fetchBaseQuery({
  baseUrl: API_URL,
  credentials: 'include',
});

export const baseQueryWithSentry: typeof baseQuery = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    if ('status' in result.error && Number(result.error.status) >= 500) {
      const url = typeof args === 'string' ? args : args.url;
      Sentry.captureMessage(`API Error: ${url} (${result.error.status})`, {
        level: 'error',
        extra: {
          args,
          error: result.error,
        },
      });
    }
  }

  return result;
};

export const api = createApi({
  baseQuery: baseQueryWithSentry,
  endpoints: () => ({}),
});
